import Vue from 'vue'
import App from './App.vue'
import i18n from './plugins/i18n'
import router from './router'
import store from './store'
import Notifications from 'vue-notification'
import Vue2Filters from 'vue2-filters'
import InfiniteLoading from 'vue-infinite-loading'
import VueCryptojs from 'vue-cryptojs'
import MarqueeText from 'vue-marquee-text-component'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './plugins/filter'

// add i18n
import zh_i18n from './i18n/mixins'

Vue.mixin(zh_i18n)
zh_i18n

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Notifications)
Vue.use(Vue2Filters)
Vue.use(InfiniteLoading)
Vue.use(VueCryptojs)
Vue.component('marquee-text', MarqueeText)

new Vue({
	i18n,
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
